import { Col, Form, Row } from "react-bootstrap";
import { HeaderRegister } from "../../components/HeaderRegister";
import { UserService } from "../../services/user.service";
import { UtilService } from "../../services/util.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { LocaleService } from '../../services/locale.service';
import { IdiomService } from '../../services/idiom.service';
import { ProfileService } from '../../services/profile.service';
import { BranchService } from '../../services/branch.service';
import { LocaleModel } from '../../models/locale.model';
import { IdiomModel } from '../../models/idiom.model';
import { UserModel } from '../../models/user.model';
import { ProfileModel } from '../../models/profile.model';
import { AlertLevelModel } from '../../models/alertLevelModel.model';
import { BranchModel } from '../../models/branch.model';
import _, { now } from 'lodash';
import { Formik } from "formik";
import * as yup from 'yup';
import { useHistory, useParams } from 'react-router-dom';
import storageService from "../../services/storage.service";
import ConfigService from "../../services/config.service";
import moment from 'moment';
import CheckboxTree from 'react-checkbox-tree';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSquare,
  faCheckSquare,
  faFolder,
  faFolderOpen,


} from "@fortawesome/free-regular-svg-icons";

import {
  faSquareFull,
  faCaretSquareRight,
  faCaretSquareDown
} from "@fortawesome/free-solid-svg-icons";
import GroupSelectMulti from "../../components/GroupSelectMulti";
import BranchSelectMulti from "../../components/BranchSelectMulti";
import LocaleCountrySelectMulti from "../../components/LocaleCountrySelectMulti";

export const UserRegister = () => {

  const user = storageService.getUser();
  const [treeviewChecked, setTreeviewChecked] = useState([]);
  const [treeviewExpanded, setTreeviewExpanded] = useState([]);

  enum TextoBoxRegisterUser {
    FullName = "fullName",
    Login = "login",
    Email = "email",
    LocaleId = "profileId",
    IdiomId = "idiomId",
    ProfileId = "localeId",
    BranchId = "branchId"
  }

  const { id } = useParams<{ id?: string }>();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [locale, setLocale] = useState<LocaleModel[]>();
  const [idiom, setIdiom] = useState<IdiomModel[]>();
  const [initialValues, setInitialValues] = useState<UserModel>({
    id: 0,
    email: '',
    login: '',
    fullName: '',
    isActive: true,
    isBlocked: false,
    localeId: undefined,
    idiomId: undefined,
    isActiveString: 'true',
    isFlagAlertString: 'false',
    profileId: undefined,
    //alertLevelId: undefined,
    branchId: '',
    lastUpdatePassword: null,
    isFlagAlertNewEquipmentString: 'false',
    Flag_Alert_New_Equipment: false,
    sendEmailAlertImpositionBalanceExceeded: false,
    sendEmailApproveScheduleBelowIdeal: false,
    ListUserLocale: [],
    ListUserBranchGroupModel: []    
  });
  const formRef = useRef();
  const history = useHistory();
  const [profile, setProfile] = useState<ProfileModel[]>();
  const [branch, setBranch] = useState<BranchModel[]>();
  const [expirationDays, setExpirationDays] = useState(90);

  const [nodes, setNodes] = useState([]);
  const [carregandoInicial, setCarregandoInicial] = useState(true);

  const [groupBranchData, setGroupBranchData] = useState<any[]>([]);
  const [isInitializingLocales, setIsInitializingLocales] = useState(true);


  const bindGroupBranch = async (dataset, update) => {
  const distinctGroups = dataset.data.filter(
    (item, i, arr) => arr.findIndex(t => t.group_id === item.group_id) === i
  );

  const gruposUnicos = distinctGroups.map(item => ({
    id: item.group_id,
    name: item.group_fullname,
  }));

  setListaDeGrupos(gruposUnicos);

  var array = [];
  var arrayGuidSelected = [];

  distinctGroups.forEach(elementGroup => {
    const branchs = dataset.data.filter(
      x => x.group_id === elementGroup.group_id
    );

    if (branchs.length === 0) return;

    var arrayChildren = [];

    branchs.forEach(element => {
      const _guid = UtilService.guid();

      if (update && element.flag_id_user) {
        arrayGuidSelected.push(_guid);
      }

      var exits = arrayChildren.some(function (el) {
        return el.branch_id === element.branch_id && el.group_id === elementGroup.group_id;
      });

      if (!exits) {
        arrayChildren.push({
          value: _guid,
          label: element.branch_fullname,
          branch_id: element.branch_id,
          group_id: element.group_id,
          branch_nickname: element.branch_nickname,
          flag_id_user: element.flag_id_user || false,
          locale_id: element.locale_id,
        });
      }
    });

    array.push({
      value: UtilService.guid(),
      group_id: elementGroup.group_id,
      label: elementGroup.group_fullname,
      children: arrayChildren
    });
  });

  setTreeviewChecked(arrayGuidSelected);
  setNodes(array);
};

  const initialize = async () => {
    if (Number(id)) {
      const response: any = await UserService.getById(id);
      if (response.success) {
        response.result.isActiveString = response.result.isActive.toString();

        response.result.isFlagAlertNewEquipmentString = response.result.flag_Alert_New_Equipment.toString();

        response.result.sendEmailAlertImpositionBalanceExceeded =
          response.result.sendEmailAlertImpositionBalanceExceeded || false;
        response.result.sendEmailApproveScheduleBelowIdeal =
          response.result.sendEmailApproveScheduleBelowIdeal || false;

        setInitialValues(response.result);

        const responseLocales: any = await UserService.getAllLocales();
        const localesUnicos = responseLocales.result
            .filter((item, index, self) =>
              index === self.findIndex((t) => t.id === item.id)
            )
            .map((item) => ({
              id: item.id,
              name: item.name,
            }));
        setListaDeLocales(localesUnicos);

        const LocalessSelecionadosIdsOri : any = await UserService.getAllLocales(Number(id));
        const LocalessSelecionadosIds = LocalessSelecionadosIdsOri.result
          .map(item => item.id)
          .filter((value, index, self) => self.indexOf(value) === index);

        setLocalesSelecionados(LocalessSelecionadosIds);

        setListaLocalesState(LocalessSelecionadosIds);

        const responseGroupBranch: any = await UserService.getGroupBranchByUserId(id);
        const dataset = _.last(_.filter(responseGroupBranch.result.datasets, { dataset: "group_branch" }));

       if (dataset?.data) {
          setGroupBranchData(dataset.data);

          const dataFiltrada = dataset.data.filter(item =>
            LocalessSelecionadosIds.includes(item.locale_id)
          );

          bindGroupBranch({ ...dataset, data: dataFiltrada }, true);

          const gruposSelecionadosIds = dataFiltrada
            .filter(item => item.flag_id_user === true)
            .map(item => item.group_id)
            .filter((value, index, self) => self.indexOf(value) === index);

          const filiaisSelecionadasIds = dataFiltrada
            .filter(item => item.flag_id_user === true)
            .map(item => item.branch_id);

          setGruposSelecionados(gruposSelecionadosIds);
          setFiliaisSelecionadas(filiaisSelecionadasIds);

          const novaLista = dataFiltrada
            .filter(item => item.flag_id_user === true)
            .map(item => ({
              value: UtilService.guid(),
              label: item.branch_fullname,
              branch_id: item.branch_id,
              group_id: item.group_id,
              branch_nickname: item.branch_nickname
            }));

          setListaInputState(novaLista);

          const gruposUnicos = dataFiltrada
            .filter((item, index, self) =>
              index === self.findIndex((t) => t.group_id === item.group_id)
            )
            .map((item) => ({
              id: item.group_id,
              name: item.group_fullname,
            }));

          setListaDeGrupos(gruposUnicos);
        }

        setIsInitializingLocales(false);
      }
    }
    else {

      const responseLocales: any = await UserService.getAllLocales();
      const localesUnicos = responseLocales.result
          .filter((item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
          )
          .map((item) => ({
            id: item.id,
            name: item.name,
          }));
      setListaDeLocales(localesUnicos);

      const responseGroupBranch: any = await UserService.getGroupBranch();
      const dataset = _.find(
        responseGroupBranch?.result?.datasets || [],
        d => d.dataset?.toLowerCase() === "group_branch"
      );

      if (dataset?.data?.length) {
        setGroupBranchData(dataset.data);
      }
    }

    var responseExpiration: any = await ConfigService.GetByKeyAndLocale(
      "PASSWORD_EXPIRATION_DAYS"
    );
    setExpirationDays(parseInt(responseExpiration.result.configValue));

    LocaleService.getAll().then((response: any) => {
      setLocale(response.result);
    });

    IdiomService.getAll().then((response: any) => {
      setIdiom(response.result);
    });

    ProfileService.getAll().then((response: any) => {
      const sort = response.result.sort((a, b) => a.profileName.localeCompare(b.profileName));
      setProfile(sort);
    });

    BranchService.getAllListForDropdown().then((response: any) => {
      setBranch(response.result);
    });

  };

  useEffect(() => {
    initialize();
  }, []);





  let validationShape = {
    fullName: yup.string().required(t('REQUIRED')),
    email: yup.string().required(t('REQUIRED')).email(t('EMAIL_VALIDATION')),
    idiomId: yup.string().required(t('REQUIRED')).test('is-numeric', t('REQUIRED'), (value) => !!value && /^[0-9]+$/.test(value)),
    localeId: yup.string().required(t('REQUIRED')).test('is-numeric', t('REQUIRED'), (value) => !!value && /^[0-9]+$/.test(value)),
    profileId: yup.string().required(t('REQUIRED')).test('is-numeric', t('REQUIRED'), (value) => !!value && /^[0-9]+$/.test(value)),
    isActiveString: yup.string().required(t('REQUIRED')),
    //alertLevelId: yup.string().required(t('REQUIRED'))
  };

  let validationShapeFull = {
    fullName: yup.string().required(t('REQUIRED')),
    email: yup.string().required(t('REQUIRED')).email(t('EMAIL_VALIDATION')),
    idiomId: yup.string().required(t('REQUIRED')).test('is-numeric', t('REQUIRED'), (value) => !!value && /^[0-9]+$/.test(value)),
    localeId: yup.string().required(t('REQUIRED')).test('is-numeric', t('REQUIRED'), (value) => !!value && /^[0-9]+$/.test(value)),
    profileId: yup.string().required(t('REQUIRED')).test('is-numeric', t('REQUIRED'), (value) => !!value && /^[0-9]+$/.test(value)),
    isActiveString: yup.string().required(t('REQUIRED')),
    branchId: yup.string().required(t('REQUIRED')),
    //alertLevelId: yup.string().required(t('REQUIRED'))
  };

  const schema = (initialValues.profileId === 4 ? yup.object().shape(validationShapeFull) : yup.object().shape(validationShape));

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  }

  const handleBlurUser = (evt: any, setFieldValue: any) => {

    if (evt.target.id === TextoBoxRegisterUser.FullName) { 

      setFieldValue('fullName', evt.target.value.toString());

    }

    else if (evt.target.id === TextoBoxRegisterUser.Login) {

      setFieldValue('login', evt.target.value.toString());

    }

    else if (evt.target.id === TextoBoxRegisterUser.Email) {

      setFieldValue('email', evt.target.value.toString());

    }
  }

  const handleChangeProfile = (evt: any, setFieldValue: any) => {
    setFieldValue("profileId", parseInt(evt.target.value.toString()));
  };

  const refreshTopBarLocalesAfterSave = async () => {
    const userLogged = storageService.getUser();

    try {
      const responseLocalesLogin: any = await UserService.getLocalesLogin();

      if (responseLocalesLogin?.success && responseLocalesLogin?.result) {
        const localesFromDb = responseLocalesLogin.result || [];

        storageService.updateUser({
          ...userLogged,
          locales: localesFromDb
        });

        window.dispatchEvent(new Event("reload-topbar-locales"));
      }
    } catch (error) {
      console.error("Erro ao recarregar locales após salvar:", error);
    }
  };

  const saveUser = async (user: UserModel) => {
    setLoading(true);

    if (user.id > 0) {
      UserService.update(user).then(async (response: any) => {
        if (response.success) {
          await refreshTopBarLocalesAfterSave();

          ToastService.success(t('USER.UPDATED'));
          history.push('/User');
        }
      }).finally(() => {
        setLoading(false);
      });
    } else {
      UserService.insert(user).then(async (response: any) => {
        if (response.success) {
          await refreshTopBarLocalesAfterSave();

          ToastService.success(t('USER.INSERTED'));
          history.push('/User');
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  const [listaDeLocales, setListaDeLocales] = useState<{ id: number; name: string }[]>([]);
  const [listaDeGrupos, setListaDeGrupos] = useState<{ id: number; name: string }[]>([]);
  const [localesSelecionados, setLocalesSelecionados] = useState<number[]>([]);
  const [gruposSelecionados, setGruposSelecionados] = useState<number[]>([]);
  const [filiaisDisponiveis, setFiliaisDisponiveis] = useState<{ id: number; name: string }[]>([]);
  const [filiaisSelecionadas, setFiliaisSelecionadas] = useState<number[]>([]);
  const [listaLocalesState, setListaLocalesState] = useState<number[]>([]);


  const handleSelecionarLocales = (ids: number[]) => {
    setLocalesSelecionados(ids);
    setListaLocalesState(ids);

    if (!groupBranchData.length) {
      setListaDeGrupos([]);
      setGruposSelecionados([]);
      setFiliaisDisponiveis([]);
      setFiliaisSelecionadas([]);
      setListaInputState([]);
      setNodes([]);
      return;
    }

    const dataFiltrada = groupBranchData.filter(item =>
      ids.includes(item.locale_id)
    );

    const datasetFiltrado = { data: dataFiltrada };

    bindGroupBranch(datasetFiltrado, !!id);

    const gruposUnicos = dataFiltrada
      .filter((item, index, self) =>
        index === self.findIndex((t) => t.group_id === item.group_id)
      )
      .map((item) => ({
        id: item.group_id,
        name: item.group_fullname,
      }));

    setListaDeGrupos(gruposUnicos);

    const gruposValidos = gruposUnicos.map(g => g.id);

    setGruposSelecionados(prev => {
      const filtrados = prev.filter(groupId => gruposValidos.includes(groupId));

      // refaz filiais com base nos grupos ainda válidos
      const filialMap = new Map<number, { name: string }>();

      dataFiltrada.forEach(item => {
        if (filtrados.includes(item.group_id)) {
          filialMap.set(item.branch_id, {
            name: `${item.branch_nickname} - ${item.branch_fullname} (${item.group_fullname})`
          });
        }
      });

      const novasFiliaisDisponiveis = Array.from(filialMap.entries()).map(([id, value]) => ({
        id,
        name: value.name
      }));

      setFiliaisDisponiveis(novasFiliaisDisponiveis);

      const filiaisValidas = novasFiliaisDisponiveis.map(f => f.id);

      setFiliaisSelecionadas(prevFiliais =>
        prevFiliais.filter(branchId => filiaisValidas.includes(branchId))
      );

      setListaInputState(prevLista =>
        prevLista.filter(item =>
          ids.includes(
            dataFiltrada.find(x =>
              x.branch_id === item.branch_id && x.group_id === item.group_id
            )?.locale_id
          )
        )
      );

      return filtrados;
    });

    if (ids.length === 0) {
      setListaDeGrupos([]);
      setGruposSelecionados([]);
      setFiliaisDisponiveis([]);
      setFiliaisSelecionadas([]);
      setListaInputState([]);
      setNodes([]);
    }
  };

  const handleSelecionarGrupos = (ids: number[]) => {
    setGruposSelecionados(ids);

    const filialMap = new Map<number, { branchNickname: string; branchLabel: string; groupNicknames: string[], flag_id_user: boolean }>();

    nodes.forEach((group) => {
      if (ids.includes(group.group_id)) {
        group.children.forEach((branch) => {
          if (!filialMap.has(branch.branch_id)) {
            filialMap.set(branch.branch_id, {
              branchLabel: branch.label,
              groupNicknames: [group.label],
              branchNickname: branch.branch_nickname,
              flag_id_user: branch.flag_id_user || false   // <-- captura flag_id_user
            });
          } else {
            filialMap.get(branch.branch_id).groupNicknames.push(group.label);
          }
        });
      }
    });

    const filiais = Array.from(filialMap.entries()).map(([branchId, { branchNickname, branchLabel, groupNicknames }]) => ({
      id: branchId,
      name: `${branchNickname} - ${branchLabel} (${groupNicknames.join(', ')})`
    }));

    setFiliaisDisponiveis(filiais);

    // Garante que as filiais marcadas anteriormente não sejam perdidas
    const filiaisSelecionadasAuto = Array.from(filialMap.entries())
      .filter(([_, { flag_id_user }]) => flag_id_user)
      .map(([branchId, _]) => branchId);

    // Junta as novas com as já selecionadas, sem duplicar
    setFiliaisSelecionadas((prev) => {
      const unicas = new Set([...prev, ...filiaisSelecionadasAuto]);
      return Array.from(unicas);
    });
  };


  const [listaInputState, setListaInputState] = useState<any[]>([]);
  useEffect(() => {
    if (carregandoInicial && nodes.length > 0 && gruposSelecionados.length > 0) {
      handleSelecionarGrupos(gruposSelecionados);
      setCarregandoInicial(false); // impede re-execução
    }
  }, [nodes, gruposSelecionados, carregandoInicial]);
  return (
    <>

      <HeaderRegister title={`${t('USER.TITLE')}  | ${window.location.hash.includes("add") ? t('REGISTRATION') : t('EDITION')}`} path={"/User"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />
      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          values.login = (values.profileId === 1 ? values.login : values.email);
          values.isActive = values.isActiveString == 'true';
          values.Flag_Alert_New_Equipment = (values.isFlagAlertNewEquipmentString == "true" ? true : false);
          values.idiomId = parseInt(values.idiomId.toString());
          values.localeId = parseInt(values.localeId.toString());
          values.profileId = parseInt(values.profileId.toString());
          //values.alertLevelId = parseInt(values.alertLevelId.toString());
          values.branchId = (values.branchId === null ? null : parseInt(values.branchId.toString()));
          values.sendEmailAlertImpositionBalanceExceeded = !!values.sendEmailAlertImpositionBalanceExceeded;
          values.sendEmailApproveScheduleBelowIdeal = !!values.sendEmailApproveScheduleBelowIdeal;


          const listaInput = [];
          filiaisDisponiveis.forEach(filial => {
            if (filiaisSelecionadas.includes(filial.id)) {
              nodes.forEach(group => {
                group.children.forEach(branch => {
                  if (branch.branch_id === filial.id) {

                    const jaExiste = listaInput.some(item =>
                      item.branch_id === branch.branch_id && item.group_id === branch.group_id
                    );

                    if (!jaExiste) {
                      listaInput.push({
                        value: UtilService.guid(), // cria um novo guid para cada entrada
                        label: branch.label,        // branch_fullname
                        branch_id: branch.branch_id,
                        group_id: branch.group_id,
                        branch_nickname: branch.branch_nickname
                      });
                    }
                  }
                });
              });
            }
          });
          const payload = {
            ...values,
            ListUserBranchGroupModel: listaInputState,
            ListUserLocale: localesSelecionados,
            ListUserGroup: gruposSelecionados
            
          };
          saveUser(payload);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          setFieldValue,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            {/* {JSON.stringify(values)} */}
            <Row className="align-items-center">
              <Col sm={12} md={6} lg={(values.profileId === 1 ? 4 : 3)} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name='fullName'
                      id='fullName'
                      type='text'
                      placeholder={t('USER.FULLNAME')} 
                      onChange={handleChange}
                      onBlur={(e) => handleBlurUser(e, setFieldValue)}
                      disabled={isLoading}
                      isInvalid={touched.fullName && !!errors.fullName}
                      value={values.fullName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fullName}
                    </Form.Control.Feedback>
                    <Form.Label>{t('USER.FULLNAME')}</Form.Label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              {initialValues.profileId === 1 && (
                <Col sm={12} md={6} lg={3} className="mb-4">
                  <Form.Group>
                    <Form.Floating>
                      <Form.Control
                        name='login'
                        id='login'
                        type='text'
                        placeholder={t('USER.LOGIN')}
                        onChange={handleChange}
                        onBlur={(e) => handleBlurUser(e, setFieldValue)}
                        disabled={isLoading}
                        isInvalid={touched.login && !!errors.login}
                        value={values.login}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.login}
                      </Form.Control.Feedback>
                      <Form.Label>{t('USER.LOGIN')}</Form.Label>
                    </Form.Floating>
                  </Form.Group>
                </Col>
              )}

              <Col sm={12} md={6} lg={3} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name='email'
                      id='email'
                      type='email'
                      placeholder={t('USER.EMAIL')}
                      onChange={handleChange}
                      disabled={isLoading}
                      onBlur={(e) => handleBlurUser(e, setFieldValue)}
                      isInvalid={touched.email && !!errors.email}
                      value={values.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                    <Form.Label>{t('USER.EMAIL')}</Form.Label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Select
                      id='profileId'
                      name='profileId'
                      isInvalid={touched.profileId && !!errors.profileId}
                      disabled={isLoading}
                      onChange={(e) => handleChangeProfile(e, setFieldValue)}
                      value={values.profileId}
                      aria-label={t("USER.PROFILE")}>
                      <option value="">{t("USER.PROFILE")}</option>
                      {_.map(profile, (l: ProfileModel) => {
                        return <option key={l.id} value={l.id}>{t(`PROFILE.${l.profileName.toUpperCase()}`)}</option>
                      })}

                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.profileId}
                    </Form.Control.Feedback>
                    <label htmlFor="profileId">{t("USER.PROFILE")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Select
                      id='idiomId'
                      name='idiomId'
                      isInvalid={touched.idiomId && !!errors.idiomId}
                      disabled={isLoading}
                      onChange={(e) => setFieldValue("idiomId", e.target.value !== "" ? e.target.value : null)}
                      value={values.idiomId}
                      aria-label={t("USER.IDIOM")}>
                      <option value="">{t("USER.IDIOM")}</option>
                      {_.map(idiom, (i: IdiomModel) => {
                        return <option key={i.id} value={i.id}>{i.name}</option>
                      })}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.idiomId}
                    </Form.Control.Feedback>
                    <label htmlFor="idiomId">{t("USER.IDIOM")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Select
                      id='localeId'
                      name='localeId'
                      isInvalid={touched.localeId && !!errors.localeId}
                      disabled={isLoading}
                      onChange={(e) => {
                        const localeId = e.target.value !== "" ? Number(e.target.value) : null;

                        setFieldValue("localeId", localeId);

                        if (localeId) {
                          handleSelecionarLocales([localeId]);
                          setFieldValue("ListUserLocale", [localeId]);
                        } else {
                          handleSelecionarLocales([]);
                          setFieldValue("ListUserLocale", []);
                        }
                      }}
                      value={values.localeId}
                      aria-label={t("USER.LOCALE")}>
                      <option value="">{t("USER.LOCALE")}</option>
                      {_.map(locale, (l: LocaleModel) => {
                        return <option key={l.id} value={l.id}>{l.name}</option>
                      })}

                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.localeId}
                    </Form.Control.Feedback>
                    <label htmlFor="localeId">{t("USER.LOCALE")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              {initialValues.profileId === 4 && (
                <Col sm={12} md={3} lg={2} className="mb-4">
                  <Form.Group>
                    <Form.Floating>
                      <Form.Select
                        id='branchId'
                        name='branchId'
                        isInvalid={touched.branchId && !!errors.branchId}
                        disabled={isLoading}
                        onChange={handleChange}
                        value={values.branchId}
                        aria-label={t("USER.BRANCH")}>
                        <option value="">{t("USER.BRANCH")}</option>
                        {_.map(branch, (l: BranchModel) => {
                          return <option key={l.id} value={l.id}>{t(`${l.fullName.toUpperCase()}`)}</option>
                        })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.branchId}
                      </Form.Control.Feedback>
                      <label htmlFor="branchId">{t("USER.BRANCH")}</label>
                    </Form.Floating>
                  </Form.Group>
                </Col>
              )}

              <Col sm={12} md={6} lg={3} className="mb-4">
                <Form.Group>
                  <Form.Label className="me-2">Status:</Form.Label>
                  <Form.Check
                    inline
                    label={t('USER.ACTIVE')}
                    disabled={isLoading}
                    name='isActiveString'
                    type='radio'
                    value='true'
                    onChange={() => {
                      setFieldValue('isActiveString', 'true');
                      setFieldValue('isActive', true);
                    }}
                    checked={values.isActiveString === 'true'}
                    feedback={
                      <Form.Control.Feedback type="invalid">
                        {errors.isActiveString}
                      </Form.Control.Feedback>
                    }
                  />
                  <Form.Check
                    inline
                    disabled={isLoading}
                    label={t('USER.INACTIVE')}
                    name='isActiveString'
                    type='radio'
                    checked={values.isActiveString === 'false'}
                    value='false'
                    onChange={() => {
                      setFieldValue('isActiveString', 'false');
                      setFieldValue('isActive', false);
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.isActiveString}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              {/* Sprint 20 - 7518 - Integrador - Notifica��o por e-mail - Cadastros de novo de cofre */}
              {values.profileId === 2 && (
                <Col sm={12} md={6} lg={3} className="mb-4" >
                  <Form.Group>
                    <Form.Label className="me-2">{t('USER.TITLE_NOTIFICATION_OF_NEW_EQUIPMENTS')}:</Form.Label>
                    <Form.Check
                      inline
                      label={t('USER.ALERT_ACTIVE')}
                      disabled={isLoading}
                      name='isFlagAlertNewEquipmentString'
                      type='radio'
                      value='true'
                      onChange={() => {
                        setFieldValue('isFlagAlertNewEquipmentString', 'true');
                        setFieldValue('Flag_Alert_New_Equipment', true);
                      }}                      
                      checked={values.isFlagAlertNewEquipmentString === 'true'}
                      feedback={
                        <Form.Control.Feedback type="invalid">
                          {errors.isFlagAlertNewEquipmentString}
                        </Form.Control.Feedback>
                      }
                    />
                    <Form.Check
                      inline
                      disabled={isLoading}
                      label={t('USER.ALERT_INACTIVE')}
                      name='isFlagAlertNewEquipmentString'
                      type='radio'
                      checked={values.isFlagAlertNewEquipmentString === 'false'}
                      value='false'
                      onChange={() => {
                        setFieldValue('isFlagAlertNewEquipmentString', 'false');
                        setFieldValue('Flag_Alert_New_Equipment', false);
                      }}                       
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.isFlagAlertNewEquipmentString}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              )}


              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name='lastUpdatePassword'
                      id='lastUpdatePassword'
                      type='text'
                      placeholder={t('USER.EXPIRES_AT')}
                      disabled={true}
                      //value={moment(values.lastUpdatePassword ?? new Date).add(expirationDays, 'd').format(user.locale.formatDate)}

                      value={UtilService.formatDate(moment(values.lastUpdatePassword ?? new Date).add(expirationDays, 'd'),user.locale.formatDate)}
                    />
                    <Form.Label>{t('USER.EXPIRES_AT')}</Form.Label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              {(values.profileId === 11 || values.profileId === 2) && (
                <Col sm={12} md={2} lg={2} className="mb-4">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="sendEmailAlertImpositionBalanceExceeded"
                      name="sendEmailAlertImpositionBalanceExceeded"
                      checked={values.sendEmailAlertImpositionBalanceExceeded}
                      onChange={(e) => setFieldValue("sendEmailAlertImpositionBalanceExceeded", e.target.checked)}
                    />
                    <label htmlFor="sendEmailAlertImpositionBalanceExceeded" className="ms-2 mb-0">
                      {t('USER.SEND_EMAIL_ALERT_IMPOSITION_BALANCE_EXCEEDED')}
                    </label>
                  </div>
                </Col>
              )}

              {(values.profileId === 11 || values.profileId === 2) && (
                <Col sm={12} md={2} lg={2} className="mb-4">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="sendEmailApproveScheduleBelowIdeal"
                      name="sendEmailApproveScheduleBelowIdeal"
                      checked={values.sendEmailApproveScheduleBelowIdeal}
                      onChange={(e) => setFieldValue("sendEmailApproveScheduleBelowIdeal", e.target.checked)}
                    />
                    <label htmlFor="sendEmailApproveScheduleBelowIdeal" className="ms-2 mb-0">
                      {t('USER.SEND_EMAIL_APPROVE_SCHEDULE_BELOW_IDEAL')}
                    </label>
                  </div>
                </Col>
              )}

            </Row>

            <Row className="align-items-start">
              {/* Coluna para o CheckboxTree */}
              <Col sm={12} md={12} lg={12} className="mb-4">

                <LocaleCountrySelectMulti
                  localeCountrys={listaDeLocales}
                  selectedLocaleCountryIds={localesSelecionados}
                  onSelect={(ids) => {
                    handleSelecionarLocales(ids);
                    setFieldValue("ListUserLocale", ids);
                  }}
                  label={t("USER.LOCALE")}
                />

                {localesSelecionados.length > 0 && (
                    <div className="mt-3">
                      <GroupSelectMulti
                        groups={listaDeGrupos}
                        selectedGroupIds={gruposSelecionados}
                        onSelect={(ids) => handleSelecionarGrupos(ids)}
                        label={t("MENU_GROUP")}
                      />
                    </div>
                )}



                {filiaisDisponiveis.length > 0 && (
                  <div className="mt-3">
                    <h6>{t('USER.AVAILABLE_BRANCHES')}</h6>
                    <BranchSelectMulti
                      branches={filiaisDisponiveis}
                      selectedIds={filiaisSelecionadas}
                      onSelect={(ids) => {
                        setFiliaisSelecionadas(ids);

                        const novaLista = listaInputState.filter(item => ids.includes(item.branch_id));

                        const novosItens = nodes.flatMap(group =>
                          group.children
                            .filter(branch => ids.includes(branch.branch_id) && !novaLista.some(item =>
                              item.branch_id === branch.branch_id && item.group_id === branch.group_id
                            ))
                            .map(branch => ({
                              value: UtilService.guid(),
                              label: branch.label,
                              branch_id: branch.branch_id,
                              group_id: branch.group_id,
                              branch_nickname: branch.branch_nickname
                            }))
                        );

                        const atualizada = [...novaLista, ...novosItens];

                        setListaInputState(atualizada);
                        setFieldValue("ListUserBranchGroupModel", atualizada);
                        setFieldValue("ListUserLocale", listaLocalesState);
                      }}


                      label={t("MENU_BRANCHES")}
                    />

                  </div>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
